import BaseApi from '../base/base'
import Course from '../../models/course'
import Material from '../../models/material'

export default class CourseApi extends BaseApi {
  constructor() {
    super()
    this.path = '/courses'
  }

  async index(params = {}) {
    this.path = '/courses'
    const response = await this.getRequest(params)
    return response.data.map((element) => new Course(element))
  }

  async show(courseId: string, params = {}) {
    this.path = `/courses/${courseId}`
    const response = await this.getRequest(params)
    return new Course(response.data)
  }

  async my(params = {}) {
    this.path = `/courses/my/`
    const response = await this.getRequest(params)
    return new Course(response.data)
  }

  async materials(params = { courseId: '0' }) {
    this.path = `/courses/${params.courseId}/materials`
    const response = await this.getRequest(params)
    return response.data.map(element => new Material(element))
  }
}
